<template>
	<b-form-group label="Usuarios">
		<b-input-group >
			<b-form-select
				@input="manageGetLocations()"
				autocomplete="off"
				:options="userOptions"
				v-model="selectedUser"
			></b-form-select>
		</b-input-group>
	</b-form-group>
</template>

<script>
import { mapState, mapMutations, mapActions } from 'vuex'
import {
	BFormInput,
	BFormGroup,
	BInputGroupAppend,
	BInputGroup,
	BButton,
	BFormSelect,
} from 'bootstrap-vue'

export default {
	components: {
		BFormGroup,
		BFormInput,
		BInputGroupAppend,
		BInputGroup,
		BButton,
		BFormSelect,
	},
	data() {
		return {
		}
	},
	computed: {
		...mapState('tableFilters', ['userOptions']),
		selectedUser: {
			set(value) {
				this.setSelectedUser(value)
			},
			get() {
				return this.$store.state.tableFilters.selectedUser
			},
		},
	},
	methods: {
		manageGetLocations() {
			this.$emit('getLocations')
		},
		...mapActions('locations', ['getLocations']),
		...mapMutations('tableFilters', ['setSelectedUser']),
		cleanSearchBar() {
			this.setInput(null)
		},
	},
}
</script>
